import React, { useContext, useEffect, useState, useRef } from "react";
import formatThousands from "format-thousands";
import DataTableRow from "./DataTableRow";
import {
  TableRow,
  Table,
  Grid,
  Typography,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableFooter,
} from "@material-ui/core";
import { ArrowUp, ArrowDown, ArrowLeftRight } from 'lucide-react';
import { makeStyles } from "@material-ui/styles";

import { InputNumber } from "antd";
import { isEmptyObject } from "../../../util/helper";
import TableEmptyState from "../../common/TableEmptyState";


const useStyles = makeStyles((theme) => ({
  colh: {
    padding: "1px 2px !important",
    // fontSize: "0.7rem",
    //  color: "#fff",
    //background: "#1c99ed",
    border: "#1px solid #ffffff",
    //fontWeight: "bold",
    // fontFamily: "poppins",
    borderBottom: "none",
  },
  colType: {
    padding: "1px 2px !important",
    fontSize: "0.7rem",
    color: "#fff",
    background: "#1c99ed",
    fontWeight: "bold",
    fontFamily: "poppins",
    borderBottom: "none",
  },
  tableLegend: {
    color: "#5e6e82",
    fontWeight: "bold",
    fontSize: "14px",
    fontFamily: "poppins",
  },
  tableContainer: {
    width: "100%",
    height: "calc(100% - 50px)",
    minHeight: 0,
    overflowY: "auto",
    overflowX: "hidden",
    paddingBottom: "40px",
    borderRadius: "0.25rem"
  },
  headingRow: {
    padding: "0.3rem 0 0.3rem 0",
    margin: "0 rem",
    background: "#edf2f9",
  },
}));
const OptionChainTable = ({
  columns,
  prevData,
  tableData,
  symbolsToStrike,
  middleStrike,
  source,
  columnIds,
  summary,
  lotSizeEnabled,
  lotSizesByToken,
  saveSymbolData,
  strikeArray,
  moreColumnStatus,
  updateScroll,
  oicepeData,
  buySellClick,
  type,
  isStraddle,
  chartClick,
  rowHover,
  height,
  width,
  info,
  isPosition
}) => {


  const [criticalPoints, setCriticalPoints] = useState({})
  const [updateScrolls, setUpdateScroll] = useState(false);
  const [strikeSortOrder, setStrikeSortOrder] = useState('asc');
  const [isFlipped, setIsFlipped] = useState(false);
  const classes = useStyles({});
  const tableContainerRef = useRef(null);
  const middleStrikeRowRef = useRef(null);

  useEffect(() => {
    if (middleStrike && tableContainerRef.current && middleStrikeRowRef.current && updateScroll) {
      const timeoutId = setTimeout(() => {
        const container = tableContainerRef.current;
        const middleRow = middleStrikeRowRef.current;

        if (container && middleRow) {
          const containerHeight = container.clientHeight;
          const rowTop = middleRow.offsetTop;
          const rowHeight = middleRow.offsetHeight;

          const scrollTop = rowTop - (containerHeight / 2) + (rowHeight / 2);

          container.scrollTo({
            top: Math.max(0, scrollTop),
            behavior: 'smooth'
          });
        }
      }, 100);

      return () => clearTimeout(timeoutId);
    }
  }, [middleStrike, updateScroll, tableData]);

  useEffect(() => {
    if (!isEmptyObject(tableData)) {
      let criticals = {};

      let maxOIchgCE = { value: 0, strike: 0 };
      let oneLowerToMaxoichgce = { value: 0, strike: 0 };
      let twoLowerToMaxoichgce = { value: 0, strike: 0 };

      let maxOIchgPE = { value: 0, strike: 0 };
      let oneLowerToMaxoichgpe = { value: 0, strike: 0 };
      let twoLowerToMaxoichgpe = { value: 0, strike: 0 };


      let maxOICE = { value: 0, strike: 0 };
      let oneLowerToMaxoice = { value: 0, strike: 0 };
      let twoLowerToMaxoice = { value: 0, strike: 0 };

      let maxOIPE = { value: 0, strike: 0 };
      let oneLowerToMaxoipe = { value: 0, strike: 0 };
      let twoLowerToMaxoipe = { value: 0, strike: 0 };


      var strikes = Object.keys(tableData);
      for (let i = 0; i < strikes.length; i++) {
        let strike = strikes[i];
        let d = tableData[strike];


        if (d.volPE > ((criticals["hightestVolPE"] && criticals["hightestVolPE"].value) || Number.MIN_VALUE)) {
          criticals["hightestVolPE"] = { value: d.volPE, strike: strike };
        }
        if (d.volCE > ((criticals["hightestVolCE"] && criticals["hightestVolCE"].value) || Number.MIN_VALUE)) {
          criticals["hightestVolCE"] = { value: d.volCE, strike: strike };
        }

        // if (d.oiPE > ((criticals["hightestOIPE"] && criticals["hightestOIPE"].value) || Number.MIN_VALUE)) {
        //   criticals["hightestOIPE"] = { value: d.oiPE, strike: strike };
        // }
        // if (d.oiCE > ((criticals["hightestOICE"] && criticals["hightestOICE"].value) || Number.MIN_VALUE)) {
        //   criticals["hightestOICE"] = { value: d.oiCE, strike: strike };
        // }


        // if (d.oiChgPE > ((criticals["hightestOIChgPE"] && criticals["hightestOIChgPE"].value) || Number.MIN_VALUE)) {
        //   criticals["hightestOIChgPE"] = { value: d.oiChgPE, strike: strike };
        // }
        // if (d.oiChgCE > ((criticals["hightestOIChgCE"] && criticals["hightestOIChgCE"].value) || Number.MIN_VALUE)) {
        //   criticals["hightestOIChgCE"] = { value: d.oiChgCE, strike: strike };
        // }

        // if (d.oiPE < ((criticals["lowestOIPE"] && criticals["lowestOIPE"].value) || Number.MAX_VALUE)) {
        //   criticals["lowestOIPE"] = { value: d.oiPE, strike: strike };
        // }
        // if (d.oiCE < ((criticals["lowestOICE"] && criticals["lowestOICE"].value) || Number.MAX_VALUE)) {
        //   criticals["lowestOICE"] = { value: d.oiCE, strike: strike };
        // }
        // if (d.oiChgPE < ((criticals["lowestOIChgPE"] && criticals["lowestOIChgPE"].value) || Number.MAX_VALUE)) {
        //   criticals["lowestOIChgPE"] = { value: d.oiChgPE, strike: strike };
        // }
        // if (d.oiChgCE < ((criticals["lowestOIChgCE"] && criticals["lowestOIChgCE"].value) || Number.MAX_VALUE)) {
        //   criticals["lowestOIChgCE"] = { value: d.oiChgCE, strike: strike };
        // }

        if (d.oiChgCE > maxOIchgCE.value) {
          twoLowerToMaxoichgce = oneLowerToMaxoichgce;
          oneLowerToMaxoichgce = maxOIchgCE;
          maxOIchgCE = { value: d.oiChgCE, strike: strike };//d.oiCE;
        } else if (d.oiChgCE > oneLowerToMaxoichgce.value) {
          twoLowerToMaxoichgce = oneLowerToMaxoichgce;
          oneLowerToMaxoichgce = { value: d.oiChgCE, strike: strike };

        } else if (d.oiChgCE > twoLowerToMaxoichgce.value) {
          twoLowerToMaxoichgce = { value: d.oiChgCE, strike: strike };
        }

        if (d.oiChgPE > maxOIchgPE.value) {
          twoLowerToMaxoichgpe = oneLowerToMaxoichgpe;
          oneLowerToMaxoichgpe = maxOIchgPE;
          maxOIchgPE = { value: d.oiChgPE, strike: strike };
        } else if (d.oiChgPE > oneLowerToMaxoichgpe.value) {
          twoLowerToMaxoichgpe = oneLowerToMaxoichgpe;
          oneLowerToMaxoichgpe = { value: d.oiChgPE, strike: strike };

        } else if (d.oiChgPE > twoLowerToMaxoichgpe.value) {
          twoLowerToMaxoichgpe = { value: d.oiChgPE, strike: strike };
        }
        // criticals["hightestOIchg_0CE"] = maxOIchgCE;
        // criticals["hightestOIchg_1CE"] = oneLowerToMaxoichgce;
        // criticals["hightestOIchg_2CE"] = twoLowerToMaxoichgce;

        // criticals["hightestOIchg_0PE"] = maxOIchgPE;
        // criticals["hightestOIchg_1PE"] = oneLowerToMaxoichgpe;
        // criticals["hightestOIchg_2PE"] = twoLowerToMaxoichgpe;


        if (d.oiCE > maxOICE.value) {
          twoLowerToMaxoice = oneLowerToMaxoice;
          oneLowerToMaxoice = maxOICE;
          maxOICE = { value: d.oiCE, strike: strike };//d.oiCE;
        } else if (d.oiCE > oneLowerToMaxoice.value) {
          twoLowerToMaxoice = oneLowerToMaxoice;
          oneLowerToMaxoice = { value: d.oiCE, strike: strike };

        } else if (d.oiCE > twoLowerToMaxoice.value) {
          twoLowerToMaxoice = { value: d.oiCE, strike: strike };
        }

        if (d.oiPE > maxOIPE.value) {
          twoLowerToMaxoipe = oneLowerToMaxoipe;
          oneLowerToMaxoipe = maxOIPE;
          maxOIPE = { value: d.oiPE, strike: strike };
        } else if (d.oiPE > oneLowerToMaxoipe.value) {
          twoLowerToMaxoipe = oneLowerToMaxoipe;
          oneLowerToMaxoipe = { value: d.oiPE, strike: strike };

        } else if (d.oiPE > twoLowerToMaxoipe.value) {
          twoLowerToMaxoipe = { value: d.oiPE, strike: strike };
        }

      }

      // criticals["hightestOI_0CE"] = maxOICE;
      // criticals["hightestOI_1CE"] = oneLowerToMaxoice;
      // criticals["hightestOI_2CE"] = twoLowerToMaxoice;

      // criticals["hightestOI_0PE"] = maxOIPE;
      // criticals["hightestOI_1PE"] = oneLowerToMaxoipe;
      // criticals["hightestOI_2PE"] = twoLowerToMaxoipe;






      setCriticalPoints(criticals);
    }
  }, [tableData])

  useEffect(() => {
    // if (moreColumnStatus && !isEmptyObject(moreColumnStatus)) {
    //setUpdateScroll(true);
    // }
  });

  const saveCriticalPoints = (obj) => {
    setCriticalPoints(obj)
  }


  const getCriticalClasses = (strike, middleStrike, type) => {
    let cls = '';

    if (type === "Straddle") {
      return cls;
    }
    Object.keys(criticalPoints)?.forEach(id => {
      if (criticalPoints[id].strike == strike) {
        cls += " " + id
      }
    })
    if (strike == middleStrike) {
      cls += " middleStrikeRow";
    } else if (strike < middleStrike) {
      cls += " middleStrikeRowLow middleStrikeRowLowColor";
    } else {
      cls += " middleStrikeRowHigh";
    }
    return cls;
  }

  const getFlippedColumns = (cols) => {
    if (!isFlipped) return cols;
    return cols.map(col => {
      if (col.includes('CE')) {
        return col.replace('CE', 'PE');
      } else if (col.includes('PE')) {
        return col.replace('PE', 'CE');
      }
      return col;
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0}}>
      <div
        ref={tableContainerRef}
        className={classes.tableContainer}
      >
        <Table stickyHeader size="small" >
          <TableHead>
            <TableRow>
              {columnIds &&
                columnIds.length > 0 &&
                getFlippedColumns(columnIds).map((column) => (
                  <TableCell
                    align={columns[column].align}
                    id="fno-table-header-cell"
                    className={`fno-table-header-cell ${classes.colh} min-w-${columns[column].minWidth}`}
                    key={columns[column].key}
                  >
                    {column === "strike" ? (
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <span>{columns[column].dataKey}</span>
                        <div style={{ display: "flex", alignItems: "center", marginLeft: "8px", gap: "6px" }}>
                          <ArrowUp
                            size={14}
                            style={{
                              cursor: "pointer",
                              display: strikeSortOrder === 'asc' ? 'block' : 'none'
                            }}
                            onClick={() => setStrikeSortOrder('desc')}
                            title="Sort Strikes Ascending"
                          />
                          <ArrowDown
                            size={14}
                            style={{
                              cursor: "pointer",
                              display: strikeSortOrder === 'desc' ? 'block' : 'none'
                            }}
                            onClick={() => setStrikeSortOrder('asc')}
                            title="Sort Strikes Descending"
                          />
                          <ArrowLeftRight
                            size={14}
                            style={{ cursor: "pointer" }}
                            onClick={() => setIsFlipped(prev => !prev)}
                            title="Flip Call/Put Columns"
                          />
                        </div>
                      </div>
                    ) : (
                      <>
                        {column === "lpCE" ? "Call " : column === "lpPE" ? "Put " : ""}   {columns[column].dataKey}
                      </>
                    )}
                  </TableCell>
                ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData &&
              Object.keys(tableData) &&
              Object.keys(tableData).length > 0 &&
              symbolsToStrike &&
              prevData &&
              Object.keys(symbolsToStrike) &&
              Object.keys(prevData) &&
              Object.keys(symbolsToStrike).length > 0 &&
              Object.keys(prevData).length > 0 &&
              strikeArray.length > 0 ? (
              strikeArray.slice().sort((a,b) => strikeSortOrder === 'asc' ? a - b : b - a).map((strike) => (
                <DataTableRow
                  key={`pe${strike}`}
                  ref={strike === middleStrike ? middleStrikeRowRef : null}
                  tokens={symbolsToStrike[strike]}
                  data={tableData[strike]}
                  columns={columns}
                  columnIds={getFlippedColumns(columnIds)}
                  middleStrike={middleStrike}
                  strike={parseFloat(strike)}
                  source={source}
                  prevData={prevData[strike]}
                  lotSizeEnabled={lotSizeEnabled}
                  lotSizesByToken={lotSizesByToken}
                  criticalPoints={criticalPoints}
                  saveCriticalPoints={saveCriticalPoints}
                  //  saveSymbolData={saveSymbolData}
                  rowClasses={getCriticalClasses(strike, middleStrike, type)}
                  oicepeData={oicepeData}
                  buySellClick={buySellClick}
                  straddlePrice={tableData[strike] ? (tableData[strike]['lpCE'] + tableData[strike]['lpPE']).toFixed(2) : 0}
                  type={type}
                  isStraddle={isStraddle}
                  chartClick={chartClick}
                  rowHover={rowHover}
                  info={info}
                  isPosition={isPosition}
                  isFlipped={isFlipped}
                />
              ))
            ) : (
              <TableEmptyState colSpan={columnIds?.length || 10} height="40vh" />
            )}
          </TableBody>

        </Table>

      </div>
    </div>
  );
};

export default OptionChainTable;
